import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/visitor-dialogs-analytics")({
  component: lazyRouteComponent(() => import("./-pages/admin.visitor-dialogs-analytics")),
  errorComponent: ({ error }) => (
    <div className="p-6 text-sm text-destructive">{error instanceof Error ? error.message : String(error)}</div>
  ),
  notFoundComponent: () => <div className="p-6">404</div>,
});
